module.exports = __webpack_public_path__ + "static/media/maestro-logo.7abaa0cf.svg";